<template>
  <div style="padding:10px;overflow:auto;height:80vh">此目录属于无内容类型,请选择其他目录</div>
</template>
<script>
export default {
  //..数据
  data() {
    return {};
  }
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/pages/gm/content/wu.vue